import React, { useState, useEffect } from 'react';
import { VERSION_STRING } from '../version';
import { useStaking } from '../hooks/useStaking';
import { useWeb3 } from '../contexts/Web3Context';
import { FaLock, FaPiggyBank, FaCoins, FaHistory, FaInfoCircle } from 'react-icons/fa';

const StakingView = () => {
    const { wallet, connectWallet } = useWeb3();
    const {
        flexibleBalance, pendingRewards, lockedDeposits, walletBalance,
        stakeFlexible, withdrawFlexible, claimFlexible,
        stakeLocked, withdrawLocked,
        loading, error, successMsg
    } = useStaking();

    const [activeTab, setActiveTab] = useState('flexible');

    // Form States
    const [flexAmount, setFlexAmount] = useState('');
    const [lockedAmount, setLockedAmount] = useState('');
    const [lockPeriod, setLockPeriod] = useState(1); // Default 90 days (Enum 1)

    // Ticker for Real-time rewards update
    const [ticker, setTicker] = useState(0);
    const [visualRewards, setVisualRewards] = useState(0);

    // Sync Visual with Blockchain Data
    useEffect(() => {
        setVisualRewards(parseFloat(pendingRewards));
    }, [pendingRewards]);

    // Simulate growth every second
    useEffect(() => {
        const interval = setInterval(() => {
            setTicker(t => t + 1);
            if (parseFloat(flexibleBalance) > 0) {
                // 24% APY / seconds in year
                const growthPerSecond = (parseFloat(flexibleBalance) * 0.24) / 31536000;
                setVisualRewards(prev => prev + growthPerSecond);
            }
        }, 1000);
        return () => clearInterval(interval);
    }, [flexibleBalance]);

    // --- RENDERS ---

    if (!wallet) {
        return (
            <div className="content-grid-dashboard">
                <div className="main-column" style={{ textAlign: 'center', padding: '50px' }}>
                    <div className="card" style={{ padding: '40px', maxWidth: '500px', margin: '0 auto' }}>
                        <h2>Staking XCOIN</h2>
                        <p style={{ marginBottom: '20px', color: '#aaa' }}>
                            Conecta tu billetera para acceder a productos de Renta Fija y gestionar tus inversiones.
                        </p>
                        <button
                            onClick={connectWallet}
                            className="buy-button"
                            style={{
                                margin: '0 auto',
                                display: 'block',
                                padding: '12px 30px',
                                fontSize: '1rem',
                                background: 'linear-gradient(90deg, #007bff, #00d2ff)'
                            }}
                        >
                            Vincular Billetera
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="content-grid-dashboard" style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            <div className="main-column" style={{ width: '100%', maxWidth: '1200px', margin: '0 auto' }}>
                {/* Header */}
                <div style={{ marginBottom: '30px', display: 'flex', alignItems: 'center', gap: '15px' }}>
                    <h2 style={{ margin: 0, fontSize: '2rem' }}>Staking XCOIN (Renta Fija)</h2>
                    <span style={{ background: '#28a745', color: 'white', padding: '4px 10px', borderRadius: '20px', fontSize: '0.8rem', fontWeight: 'bold' }}>Live {VERSION_STRING}</span>
                </div>

                {/* Notifications */}
                {error && <div className="alert alert-danger" style={{ marginBottom: '20px' }}>{error}</div>}
                {successMsg && <div className="alert alert-success" style={{ marginBottom: '20px' }}>{successMsg}</div>}

                {/* Prominent Selection Tabs */}
                {/* Helper Text */}
                {/* Helper Text */}
                <h3 style={{ textAlign: 'center', marginBottom: '20px', fontSize: '1.5rem' }}>
                    Selecciona entre Ahorro Flexible o Depósito a Plazo
                </h3>

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '30px' }}>
                    <div
                        onClick={() => setActiveTab('flexible')}
                        className={activeTab === 'flexible' ? 'staking-tab active' : 'staking-tab'}
                        style={{
                            cursor: 'pointer',
                            background: activeTab === 'flexible' ? 'linear-gradient(135deg, rgba(0,123,255,0.2) 0%, rgba(0,123,255,0.05) 100%)' : '#222',
                            border: activeTab === 'flexible' ? '2px solid #007bff' : '1px solid #444',
                            borderRadius: '15px',
                            padding: '25px',
                            textAlign: 'center',
                            transition: 'all 0.2s ease',
                            transform: activeTab === 'flexible' ? 'translateY(-2px)' : 'scale(0.98)',
                            boxShadow: activeTab === 'flexible' ? '0 10px 20px rgba(0,0,0,0.2)' : 'none',
                            opacity: activeTab === 'flexible' ? 1 : 0.7
                        }}
                    >
                        <FaPiggyBank size={40} color={activeTab === 'flexible' ? '#007bff' : '#888'} style={{ marginBottom: '15px' }} />
                        <h3 style={{ margin: 0, color: activeTab === 'flexible' ? '#fff' : '#ccc' }}>Ahorro Flexible</h3>
                        <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: activeTab === 'flexible' ? '#007bff' : '#666', marginTop: '5px' }}>2% <span style={{ fontSize: '0.9rem', color: '#aaa' }}>Rentabilidad Mensual</span></div>
                        <p style={{ fontSize: '0.9rem', color: '#888', marginTop: '10px' }}>Retiros en cualquier momento</p>
                    </div>

                    <div
                        onClick={() => setActiveTab('locked')}
                        className={activeTab === 'locked' ? 'staking-tab active' : 'staking-tab'}
                        style={{
                            cursor: 'pointer',
                            background: activeTab === 'locked' ? 'linear-gradient(135deg, rgba(255,152,0,0.2) 0%, rgba(255,152,0,0.05) 100%)' : '#222',
                            border: activeTab === 'locked' ? '2px solid #ff9800' : '1px solid #444',
                            borderRadius: '15px',
                            padding: '25px',
                            textAlign: 'center',
                            transition: 'all 0.2s ease',
                            transform: activeTab === 'locked' ? 'translateY(-2px)' : 'scale(0.98)',
                            boxShadow: activeTab === 'locked' ? '0 10px 20px rgba(0,0,0,0.2)' : 'none',
                            opacity: activeTab === 'locked' ? 1 : 0.7
                        }}
                    >
                        <FaLock size={40} color={activeTab === 'locked' ? '#ff9800' : '#888'} style={{ marginBottom: '15px' }} />
                        <h3 style={{ margin: 0, color: activeTab === 'locked' ? '#fff' : '#ccc' }}>Plazo Fijo</h3>
                        <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: activeTab === 'locked' ? '#ff9800' : '#666', marginTop: '5px' }}>Hasta 3.5% <span style={{ fontSize: '0.9rem', color: '#aaa' }}>Rentabilidad Mensual</span></div>
                        <p style={{ fontSize: '0.9rem', color: '#888', marginTop: '10px' }}>Mayor rendimiento, fondos bloqueados</p>
                    </div>
                </div>

                {/* --- FLEXIBLE CONTENT --- */}
                {activeTab === 'flexible' && (
                    <div className="card" style={{ padding: '30px', animation: 'fadeIn 0.5s' }}>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '30px', marginBottom: '40px' }}>
                            {/* Balance Card */}
                            <div style={{ background: 'rgba(255,255,255,0.05)', padding: '25px', borderRadius: '15px' }}>
                                <h4 style={{ margin: '0 0 15px 0', color: '#ccc', display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <FaCoins /> Tu Saldo en Staking
                                </h4>
                                <div style={{ fontSize: '2.2rem', fontWeight: 'bold', letterSpacing: '1px' }}>
                                    {parseFloat(flexibleBalance).toFixed(6)} XCO
                                </div>
                                <div style={{ color: '#aaa', fontSize: '0.9rem', marginTop: '5px' }}>≈ Recibes 2% pago mensual (0.066% diario)</div>
                            </div>

                            {/* Rewards Card */}
                            <div style={{ background: 'rgba(76, 175, 80, 0.08)', padding: '25px', borderRadius: '15px', border: '1px solid rgba(76, 175, 80, 0.3)' }}>
                                <h4 style={{ margin: '0 0 15px 0', color: '#4caf50' }}>Ganancias Pendientes (Live)</h4>
                                <div style={{ fontSize: '2.2rem', fontWeight: 'bold', color: '#4caf50', letterSpacing: '1px' }}>
                                    +{(() => {
                                        return parseFloat(pendingRewards).toFixed(8);
                                    })()} XCO
                                </div>
                                <button
                                    onClick={claimFlexible}
                                    disabled={parseFloat(pendingRewards) <= 0 || loading}
                                    className="action-btn"
                                    style={{ marginTop: '15px', width: '100%', background: '#4caf50', fontSize: '1.1rem', padding: '12px' }}
                                >
                                    Reclamar Ganancias
                                </button>
                            </div>
                        </div>

                        {/* Actions */}
                        <div style={{ borderTop: '1px solid rgba(255,255,255,0.1)', paddingTop: '30px' }}>
                            <h4 style={{ marginBottom: '20px' }}>Gestionar Fondos</h4>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '30px' }}>
                                {/* Deposit */}
                                <div>
                                    <label style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                                        <span>Depositar XCO</span>
                                        <span style={{ fontSize: '0.85rem', color: '#4caf50' }}>Disp: {parseFloat(walletBalance).toFixed(2)} XCO</span>
                                    </label>
                                    <div className="input-group" style={{ display: 'flex', gap: '10px' }}>
                                        <input
                                            type="number"
                                            className="dark-input"
                                            style={{ flex: 1, padding: '12px', borderRadius: '8px', border: '1px solid #444', background: '#222', color: 'white' }}
                                            placeholder="Cantidad"
                                            value={flexAmount}
                                            onChange={(e) => setFlexAmount(e.target.value)}
                                        />
                                        <span style={{ alignSelf: 'center', fontWeight: 'bold' }}>XCO</span>
                                    </div>
                                    <button
                                        className="buy-button"
                                        style={{ marginTop: '15px', width: '100%', padding: '12px' }}
                                        disabled={loading || !flexAmount || parseFloat(flexAmount) > parseFloat(walletBalance) || parseFloat(flexAmount) <= 0}
                                        onClick={() => stakeFlexible(flexAmount)}
                                    >
                                        {loading ? 'Procesando...' : 'Depositar'}
                                    </button>
                                </div>

                                {/* Withdraw */}
                                <div>
                                    <label style={{ marginBottom: '8px', display: 'block' }}>Retirar XCO</label>
                                    <div className="input-group" style={{ display: 'flex', gap: '10px' }}>
                                        <input
                                            type="number"
                                            className="dark-input"
                                            style={{ flex: 1, padding: '12px', borderRadius: '8px', border: '1px solid #444', background: '#222', color: 'white' }}
                                            placeholder="Cantidad"
                                            value={flexAmount}
                                            onChange={(e) => setFlexAmount(e.target.value)}
                                        />
                                        <span style={{ alignSelf: 'center', fontWeight: 'bold' }}>XCO</span>
                                    </div>
                                    <button
                                        className="market-button"
                                        style={{ marginTop: '15px', width: '100%', justifyContent: 'center', background: '#dc3545', borderColor: '#dc3545', padding: '12px' }}
                                        disabled={loading || !flexAmount}
                                        onClick={() => withdrawFlexible(flexAmount)}
                                    >
                                        {loading ? 'Procesando...' : 'Retirar'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* --- LOCKED CONTENT --- */}
                {activeTab === 'locked' && (
                    <div style={{ animation: 'fadeIn 0.5s' }}>
                        {/* New Deposit Form */}
                        <div className="card" style={{ padding: '30px', marginBottom: '20px' }}>
                            <h3><FaHistory style={{ marginRight: '10px' }} /> Crear Nuevo Depósito a Plazo</h3>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '30px', marginTop: '20px' }}>

                                {/* Amount Input */}
                                <div>
                                    <label style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                                        <span>Cantidad a Bloquear</span>
                                        <span style={{ fontSize: '0.85rem', color: '#4caf50' }}>Disp: {parseFloat(walletBalance).toFixed(2)} XCO</span>
                                    </label>
                                    <div className="input-with-label">
                                        <input
                                            type="number"
                                            style={{ padding: '12px' }}
                                            placeholder="0.00"
                                            value={lockedAmount}
                                            onChange={(e) => setLockedAmount(e.target.value)}
                                        />
                                        <span>XCO</span>
                                    </div>
                                    {parseFloat(lockedAmount) > parseFloat(walletBalance) && (
                                        <div style={{ color: '#ff4d4d', fontSize: '0.8rem', marginTop: '5px' }}>Saldo insuficiente</div>
                                    )}
                                </div>

                                {/* Period Selector */}
                                <div>
                                    <label style={{ marginBottom: '8px', display: 'block' }}>Seleccionar Plazo</label>
                                    <div className="market-tabs" style={{ margin: 0, display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '10px' }}>
                                        <button
                                            className={`market-button ${lockPeriod === 0 ? 'active' : ''}`}
                                            onClick={() => setLockPeriod(0)}
                                            style={{ display: 'flex', justifyContent: 'center', textAlign: 'center', flexDirection: 'column', padding: '10px', gap: '5px' }}
                                        >
                                            <span style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>30</span>
                                            <span style={{ fontSize: '0.8rem' }}>Días</span>
                                            <small style={{ color: '#4caf50' }}>2.5% M.</small>
                                        </button>
                                        <button
                                            className={`market-button ${lockPeriod === 1 ? 'active' : ''}`}
                                            onClick={() => setLockPeriod(1)}
                                            style={{ display: 'flex', justifyContent: 'center', textAlign: 'center', flexDirection: 'column', padding: '10px', gap: '5px' }}
                                        >
                                            <span style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>90</span>
                                            <span style={{ fontSize: '0.8rem' }}>Días</span>
                                            <small style={{ color: '#4caf50' }}>3.0% M.</small>
                                        </button>
                                        <button
                                            className={`market-button ${lockPeriod === 2 ? 'active' : ''}`}
                                            onClick={() => setLockPeriod(2)}
                                            style={{ display: 'flex', justifyContent: 'center', textAlign: 'center', flexDirection: 'column', padding: '10px', gap: '5px' }}
                                        >
                                            <span style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>180</span>
                                            <span style={{ fontSize: '0.8rem' }}>Días</span>
                                            <small style={{ color: '#4caf50' }}>3.5% M.</small>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <button
                                className="buy-button"
                                style={{ marginTop: '30px', width: '100%', padding: '15px', fontSize: '1.1rem' }}
                                disabled={loading || !lockedAmount || parseFloat(lockedAmount) > parseFloat(walletBalance) || parseFloat(lockedAmount) <= 0}
                                onClick={() => stakeLocked(lockedAmount, lockPeriod)}
                            >
                                {loading ? 'Bloqueando XCO...' : 'Confirmar Bloqueo de Fondos'}
                            </button>
                            <div style={{ marginTop: '15px', fontSize: '0.9rem', color: '#ff9800', display: 'flex', alignItems: 'center', gap: '8px', background: 'rgba(255,152,0,0.1)', padding: '10px', borderRadius: '8px' }}>
                                <FaInfoCircle />
                                <span>Advertencia: Los fondos NO podrán retirarse antes de la fecha de vencimiento elegida.</span>
                            </div>
                        </div>

                        {/* Active Deposits List */}
                        <h3 style={{ marginTop: '30px' }}>Mis Depósitos Activos</h3>
                        {lockedDeposits.length === 0 ? (
                            <div className="card" style={{ padding: '40px', textAlign: 'center', opacity: 0.6 }}>
                                <FaHistory size={40} style={{ marginBottom: '15px' }} />
                                <p>No tienes depósitos a plazo activos.</p>
                            </div>
                        ) : (
                            <div style={{ display: 'grid', gap: '15px' }}>
                                {lockedDeposits.map((dep, idx) => {
                                    const nowSeconds = Math.floor(Date.now() / 1000);
                                    const effectiveTime = Math.min(nowSeconds, dep.unlockTime);
                                    const duration = Math.max(0, effectiveTime - dep.startTime);
                                    const accrued = (parseFloat(dep.amount) * (dep.apy / 100) * duration) / 31536000;
                                    const monthlyRate = dep.apy / 12;

                                    return (
                                        <div key={idx} className="card" style={{ padding: '25px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderLeft: dep.withdrawn ? '5px solid #666' : '5px solid #007bff' }}>
                                            <div>
                                                <div style={{ fontSize: '1.4rem', fontWeight: 'bold' }}>{parseFloat(dep.amount).toFixed(2)} XCO</div>
                                                <div style={{ color: '#aaa', marginTop: '5px' }}>
                                                    Plazo: <strong style={{ color: 'white' }}>{dep.period === 0 ? '30 Días' : dep.period === 1 ? '90 Días' : '180 Días'}</strong>
                                                    {' '}@ <span style={{ color: '#4caf50' }}>{monthlyRate.toFixed(1)}% Mensual</span>
                                                </div>
                                                <div style={{ fontSize: '0.9rem', marginTop: '5px', opacity: 0.8 }}>
                                                    Desbloqueo: {new Date(dep.unlockTime * 1000).toLocaleDateString()}
                                                </div>
                                            </div>

                                            <div style={{ textAlign: 'right' }}>
                                                <div style={{ fontSize: '1.2rem', color: '#4caf50', marginBottom: '10px', fontWeight: 'bold' }}>
                                                    +{accrued.toFixed(6)} XCO
                                                </div>
                                                {dep.withdrawn ? (
                                                    <span className="badge" style={{ background: '#666', padding: '8px 12px' }}>Finalizado</span>
                                                ) : (
                                                    Date.now() / 1000 >= dep.unlockTime ? (
                                                        <button
                                                            className="action-btn"
                                                            style={{ background: '#28a745', padding: '8px 15px' }}
                                                            onClick={() => withdrawLocked(idx)}
                                                            disabled={loading}
                                                        >
                                                            Retirar (+Interés)
                                                        </button>
                                                    ) : (
                                                        <span className="badge" style={{ background: '#ff9800', color: 'black', padding: '8px 12px', display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                            <FaLock size={12} /> Bloqueado
                                                        </span>
                                                    )
                                                )}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                )}
            </div>

            {/* Info Section Moved to Bottom */}
            <div style={{ width: '100%', maxWidth: '1200px', margin: '20px auto 0' }}>
                <div className="card" style={{ padding: '25px', background: 'rgba(255,255,255,0.03)', border: '1px dashed rgba(255,255,255,0.1)' }}>
                    <h4 style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}><FaInfoCircle /> ¿Cómo funciona?</h4>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' }}>
                        <div>
                            <strong style={{ color: '#007bff' }}>Ahorro Flexible</strong>
                            <p style={{ fontSize: '0.9rem', color: '#aaa', marginTop: '5px' }}>
                                Deposita y retira cuando quieras. Los intereses (2% Mensual) se calculan segundo a segundo. Debes reclamar tus ganancias manualmente.
                            </p>
                        </div>
                        <div>
                            <strong style={{ color: '#ff9800' }}>Plazo Fijo</strong>
                            <p style={{ fontSize: '0.9rem', color: '#aaa', marginTop: '5px' }}>
                                Ganas una tasa más alta (hasta 3.5% Mensual), pero tus fondos quedan custodiados por el contrato inteligente hasta la fecha final.
                            </p>
                        </div>
                        <div>
                            <strong style={{ color: '#4caf50' }}>Pago de Intereses</strong>
                            <p style={{ fontSize: '0.9rem', color: '#aaa', marginTop: '5px' }}>
                                Todos los intereses se pagan en XCO provenientes de la Tesorería de Recompensas.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StakingView;
